module.exports = __webpack_public_path__ + "static/img/why-5.11e19121.jpg";